module.exports = __webpack_public_path__ + "img/vn3-coal-based-power.53b6954e.jpg";